import styled from 'styled-components';
import { CSSProperties } from 'react';
import TextField from '@mui/material/TextField';
import FilledInput from '@mui/material/FilledInput';

import { Subhead02 } from '../typography/typography';
import { InputStyle } from '../../global-styles/form-styles';
import { theme } from '../../global-styles/colors';

export const AlxTextField = styled(TextField)`
  /* width: 100%;
  .MuiFilledInput-root {
    border: 1px solid ${theme.divider_and_border.input_border_hover};
    background: none;
    border-radius: 4px;
    ${Subhead02};
  }
  .MuiFilledInput-underline:before,
  .MuiFilledInput-underline:after {
    display: none;
  }

  .MuiInputLabel-root {
    ${Subhead02};
  } */
  ${InputStyle}
`;
export const AlxFilledInput = styled(FilledInput)`
  /* &.MuiInputBase-root {
    width: 100%;
    border: 1px solid ${theme.divider_and_border.input_border_hover};
    background: none;
    border-radius: 4px;
    ${Subhead02};
    &:before,
    &:after {
      display: none;
    }
  }

  &.MuiInputLabel-root {
    ${Subhead02};
  } */
  ${InputStyle}
`;

export const themeColors = {
  '00000016': { '--color': '#0094D9', '--focus': '#0094D9' } as CSSProperties,
  '00000001': { '--color': '#DC0028', '--focus': '#DC0028' } as CSSProperties,
  '00000002': { '--color': '#DC0028', '--focus': '#DC0028' } as CSSProperties,
  '00000006': { '--color': '#E2001A', '--focus': '#E2001A' } as CSSProperties,
  '00000011': { '--color': '#5BD1D7', '--focus': '#5BD1D7' } as CSSProperties,
  '00000010': { '--color': '#003082', '--focus': '#003082' } as CSSProperties,
  '00000020': { '--color': '#DC0028', '--focus': '#DC0028' } as CSSProperties,
  '00000025': { '--color': '#004B9B', '--focus': '#004B9B' } as CSSProperties,
  '00000007': { '--color': '#141476', '--focus': '#141476' } as CSSProperties,
};
